module.exports = __webpack_public_path__ + "static/media/icon-dialog.dab38905.svg";